import React, { useEffect, createElement } from 'react';
import AdvertorialGlpAdv2 from '../components/AdvertorialGlpAdv2';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpAdv2Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18459" data-mp="1t9055du9h3ra">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18460" data-mp="1ya5y9cru2t1c">
        <Helmet data-id="element-18461" data-mp="1y9nwy1qbdomk">
          <title data-id="element-18462" data-mp="1y83br2pw3i1d">
            Endocrinologist Investigates: Does Semaglutide Actually Damage
            Mental Health—And Why Isn't Anyone Warning You?
          </title>
          <meta property="og:title" content="Endocrinologist Investigates: Does Semaglutide Actually Damage Mental Health—And Why Isn't Anyone Warning You?" data-id="element-18463" data-mp="1oaouj0w56p80" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18464" data-mp="cwl6scg5dxbe" />
          <meta property="og:type" content="article" data-id="element-18465" data-mp="fbhv0omf0ile" />
          <meta property="og:url" content={window.location.href} data-id="element-18466" data-mp="fa6uqys6hsz1" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18467" data-mp="abvk4lu27efr" />
          <meta property="og:image:width" content="1200" data-id="element-18468" data-mp="3ishxn9xjs11r" />
          <meta property="og:image:height" content="630" data-id="element-18469" data-mp="3dtwvh4yqj7ao" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18470" data-mp="3draop7jo4vti" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18471" data-mp="3sjcjid6vsymo" />
          <meta name="twitter:title" content="Endocrinologist Investigates: Does Semaglutide Actually Damage Mental Health—And Why Isn't Anyone Warning You?" data-id="element-18472" data-mp="3nqa0v03n79l9" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18473" data-mp="2v2nmcwsvmkjm" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18474" data-mp="22arhsajxnr0z" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18475" data-mp="27b5kdd2rm8rm" />
        </Helmet>
        <AdvertorialGlpAdv2 data-id="element-18476" data-mp="2h29x064yxhja" />
      </div>
    </HelmetProvider>;
}